module.exports = __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-12-e0d6d776731bf3867d6c0f9355dbd2e1.png";